/**
 * Obiekt konfiguracyjny aplikacji.
 *
 * @typedef {Object} Config
 */
const config = {
  runmode: {
    debug: false,
  },
  maintenance: {
    enabled: false,
    title: "Przerwa techniczna",
    message: null,
    details: null,
    plannedReturn: null,
    contactEmail: null,
  },
  aiAssistant: {
    enabled: true,
  },
  isztarValidation: {
    enabled: false,
  },
  info: {
    version: "v. 20261104.01.01-VIP_TEST",
    meta: {
      name: "Krajowa Izba Gospodarcza",
      address: "ul. Trębacka 4, 00-074 Warszawa",
      bussinesData: "NIP: 526 000 17 08 | Regon: 006210187",
      email: "swiadectwapochodzenia@kig.pl",
    },
  },
};

export default config;
